import 'pages/products/parameters/feature-new-edit-modal.tag'
riot.tag2('product-edit-parameters', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" add="{addParameters}" handlers="{parametersHandlers}" cols="{parametersCols}" rows="{value}" responsive="false" remove="true" limit="199">\n        <yield to="toolbar">\n          <yield from="toolbar"></yield>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="value">\n            <input class="form-control" if="{row.type == &quot;number&quot;}" value="{row.valueNumber}" min="0.00" oninput="{handlers.changeValue}" type="{\'number\'}"><i class="fa fa-fw {row.valueBool ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.type == &quot;bool&quot;}" onclick="{handlers.toggleCheckbox}"></i>\n            <input class="form-control" if="{row.type == &quot;string&quot;}" value="{row.valueString}" type="text" oninput="{handlers.changeValue}">\n            <autocomplete if="{row.type == &quot;colorlist&quot;}" load-data="{handlers.getOptions(row.idFeature)}" value="{row.idValue}" value-field="value" id-field="id" onchange="{handlers.changeColorValue}"><i class="color" riot-style="background-color: #{item.color};"></i>&nbsp;&nbsp;{item.value}</autocomplete>\n            <autocomplete if="{row.type == &quot;list&quot;}" load-data="{handlers.getOptions(row.idFeature)}" value="{row.idValue}" text="{row.resvalue}" value-field="value" id-field="id" onchange="{handlers.changeColorValue}" add="{handlers.addParam}">{item.value}</autocomplete>\n          </datatable-cell>\n          <datatable-cell name="modificationId">\n            <select class="form-control" name="idModification" value="{row.idModification}" onchange="{handlers.changeselect}">\n              <option value="">Для всех</option>\n              <optgroup each="{mod in parent.parent.parent.parent.modifications}" label="{mod.name}">\n                <option each="{mi in mod.items}" value="{mi.id}" __selected="{row.idModification==mi.id}" no-reorder>{mi.values[0].value}</option>\n              </optgroup>\n            </select>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.modifications = [];

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value || [];
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.parametersCols = [{ name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: 'modificationId', value: 'Модификация' }];

self.addParameters = function (e) {
    modals.create('parameters-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            self.value = self.value || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.value.map(function (item) {
                return item.idFeature;
            });

            items.forEach(function (item) {
                //  if (ids.indexOf(item.id) === -1) {
                self.value.push({
                    idFeature: item.id,
                    name: item.name,
                    type: item.type
                });
                //}
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
            this.modalHide();
        }
    });
};
console.log(opts);
// Параметры Обработчики
self.parametersHandlers = {
    getOptions: function getOptions(id) {
        var id = id;
        return function () {
            var _this = this;
            return API.request({
                object: 'FeatureValue',
                method: 'Fetch',
                data: { filters: { field: 'idFeature', value: id } },
                success: function success(response) {
                    _this.data = response.items;
                    if (!_this.isOpen) {
                        _this.data.forEach(function (item) {
                            if (item[_this.idField] == _this.opts.value) {
                                _this.filterValue = item[_this.valueField];
                            }
                        });
                    }
                    _this.update();
                }
            });
        };
    },

    // переключатель
    toggleCheckbox: function toggleCheckbox(e) {
        this.row.valueBool = !this.row.value;
    },

    // изменить значение
    changeValue: function changeValue(e) {
        if (e.target.type == '' || e.target.type == 'text') {
            var selectionStart = e.target.selectionStart;
            var selectionEnd = e.target.selectionEnd;
            this.row.valueString = e.target.value;
            this.update();
            e.target.selectionStart = selectionStart;
            e.target.selectionEnd = selectionEnd;
        } else if (e.target.type == 'number') {
            this.row.valueNumber = e.target.value;
            this.update();
        } else
            // если тип цели bool...
            if (e.target.type == 'bool') {
                this.row.valueBool = e.target.value;
                this.update();
            }
    },
    changeColorValue: function changeColorValue(e) {
        this.row.idValue = this.row.valueIdList = e.target.value;
        //console.log(e.target)
    },
    changeListValue: function changeListValue(e) {
        this.row.idValue = this.row.valueIdList = e.target.value;
    },

    modifications: self.modifications,
    changeselect: function changeselect(e) {
        e.item.row.idModification = e.target.value;
    },
    addParam: function addParam(e) {
        //console.log(this)
        var pthis = this,
            idFeature = pthis.parent.row.idFeature,
            idValue = pthis.parent.row.idValue,
            data = pthis.data,
            itemval = [],
            f = false;

        itemval.value = this.filterValue || '';
        data.forEach(function (item) {
            if (item.value == itemval.value) {
                pthis.parent.row.idValue = item.id;
                pthis.opts.value = item.id;
                pthis.parent.row.value = itemval.value;
                pthis.value = item.id;
                f = true;
                //self.update()
                return;
            }
        });
        if (f) return;

        modals.create('feature-new-edit-modal', {
            type: 'modal-primary',
            typeparam: pthis.type,
            item: itemval,
            submit: function submit() {
                var _this = this,
                    params = {};

                _this.error = _this.validation.validate(_this.item, _this.rules);
                data.forEach(function (item) {
                    if (item.value == _this.item.value) {
                        _this.error = true;
                    }
                });

                if (!_this.error) {
                    params.idFeature = idFeature;
                    params.value = _this.item.value;
                    params.image = _this.item.image;
                    params.color = _this.item.color;
                    params.code = _this.item.code;

                    API.request({
                        object: 'FeatureValue',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            pthis.parent.row.idValue = response.id;
                            pthis.value = response.id;
                            pthis.opts.value = response.id;
                            pthis.parent.row.value = itemval.value;
                            data.push(response);
                            _this.modalHide();
                        }
                    });
                }
            }
        });
    }
};

self.on('update', function () {
    if ('value' in opts) self.value = opts.value || [];

    if ('modifications' in opts) self.modifications = opts.modifications || [];

    if ('name' in opts) self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-parameters.tag